import GrupoFinanceiroService from "@/services/GrupoFinanceiroService";

export const actions = {
  cadastrarGrupoFinanceiro: ({ commit, dispatch }) => {
    commit("setGrupoFinanceiro", {
      nome: "",
    }),
      dispatch("setModalCadastroGrupoFinanceiro", true);
  },
  listarGrupoFinanceiro: ({ commit }, data) => {
    commit("setOverlay", true);
    GrupoFinanceiroService.listar(data)
      .then((res) => {
        commit("setOverlay", false);
        commit("setGruposFinanceiro", res.data);
      })
      .catch((e) => {
        commit("setOverlay", false);
        console.log(e);
      });
  },
  visualizarGrupoFinanceiro: ({ commit, dispatch }, data) => {
    commit("setGrupoFinanceiro", { ...data });
    dispatch("setModalCadastroGrupoFinanceiro", true);
  },

  salvarGrupoFinanceiro: ({ commit, dispatch }, data) => {
    commit("setOverlay", true);
    GrupoFinanceiroService.salvar(data)
      .then((res) => {
        commit("setGrupoFinanceiro", res.data);
        commit("addGrupoFinanceiro", res.data);
        commit("setOverlay", false);
        commit("snackbarSuccess", "Registro salvo.");
        commit("setModalCadastroGrupoFinanceiro", false);
      })
      .catch((e) => {
        if (e.response.status == 422) {
          commit("alertError", e.response.data.errors);
        }
        console.log(e);
        commit("setOverlay", false);
        commit("snackbarError", "Erro ao cadastrar.");
      });
  },
  atualizarGrupoFinanceiro: ({ commit, dispatch }, data) => {
    commit("setOverlay", true);
    GrupoFinanceiroService.atualizar(data)
      .then((res) => {
        dispatch("listarGrupoFinanceiro");
        commit("setOverlay", false);
        commit("snackbarInfo", "Registro atualizado.");
      })
      .catch((e) => {
        if (e.response.status == 422) {
          commit("alertError", e.response.data.errors);
        }
        console.log(e);
        commit("setOverlay", false);
        commit("snackbarError", "Erro ao atualizar.");
      });
  },
  excluirGrupoFinanceiro: ({ commit, dispatch }, data) => {
    dispatch("setModalExcluirGrupoFinanceiro", false);
    dispatch("setModalCadastroGrupoFinanceiro", false);
    commit("setOverlay", true);
    GrupoFinanceiroService.excluir(data.id)
      .then((res) => {
        commit("removeGrupoFinanceiro", res.data);
        commit("setOverlay", false);
        commit("snackbarError", "Registro excluído.");
      })
      .catch((e) => {
        commit("snackbarError", "Erro ao atualizar.");
      });
  },
  setModalCadastroGrupoFinanceiro: ({ commit }, status) => {
    commit("setModalCadastroGrupoFinanceiro", false);
    setTimeout(() => {
      commit("setModalCadastroGrupoFinanceiro", status);
    }, 100);
  },
  setModalExcluirGrupoFinanceiro: ({ commit }, status) => {
    commit("setModalExcluirGrupoFinanceiro", false);
    setTimeout(() => {
      commit("setModalExcluirGrupoFinanceiro", status);
    }, 100);
  },

};

export default {};
